import { Add } from '@mui/icons-material';
import { Autocomplete, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React,{useEffect, useState} from 'react'
import { useAppData } from '../../../../../context/AppDataContext';
import inventoryServices from '../../inventory/inventoryServices';
import invoiceItemServices from '../invoiceItemServices';
import { useAlert } from '../../../../../context/AlertContext';
import SelectProduct from '../../product/components/SelectProduct';
import InventoryForm from '../../inventory/components/InventoryForm';

function InvoiceItemForm({invoiceDetails, productList, callBack}) {
    const { projectLocationDD, getDDDataById} = useAppData();
    const [selectedProduct,setSelectedProduct] = useState(null);
    const {AppAlert} = useAlert();

    const [item,setItem] = useState(null);

    const [stockList,setStockList] = useState(null);

    const getStockList = () =>{
        console.log("getting stockList");
        console.log(invoiceDetails);
        console.log(item);
        inventoryServices.getBillingStock(invoiceDetails.companyId,item.id).then(res=>{
            setStockList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    } 
    
    

    

    const handleItemChange = (key,value) =>{
        let _item = {...item};
        _item[key] = value === "" ? "" :value;
        setItem(_item);
    }

    useEffect(()=>{
        if(selectedProduct){
            let _item = {...selectedProduct}
            _item['qty'] = 0;
            _item['stockId'] = 0;
            setItem(_item);
            console.log(_item);
            /*
            if(selectedProduct?.billingType == 1){
                getStockList(); 
            }
            */
            setSelectedProduct(null)
        }
        
    },[selectedProduct])


    useEffect(()=>{
        if(item?.billingType == 1){
            getStockList(); 
        }
    },[item])

    const [errorList,setErrorList] = useState([]);

    const validateItemDetails = () =>{
        
        let _errorList = [];

        if(item.billingType == 1 && item.locationId == 0 ){
            _errorList.push("No Warehouse Selected")
        }
        if(item.billingType == 1 && item.locationId != 0 ){
            //_errorList.push("Please Select A Warehouse")
        }
        if(item.qty == 0){
            _errorList.push("Qty can not be 0")
        }

        
        setErrorList(_errorList);
        if(_errorList.length >0){
            return false;
        }
        return true;

    }

    const addItem = () => {
        console.log("readyto add item");
        console.log(item);
        item.invoiceId = invoiceDetails.id;
        item.productId = item.id;
        item.amount = Number(item.qty* item.price);
        item.gstAmount = Number((item.amount * item.gstRate) / 100);
        item.totalAmount = Number(item.amount + item.gstAmount);
        
        if(validateItemDetails()){
            invoiceItemServices.save(item).then(res=>{
                console.log(res.data)
                AppAlert(res.msg);
            }).catch(error=>{
                console.log(error);
                AppAlert(error.msg,"error");
            }).finally(()=>{
                callBack();
                setItem(null);
            })
        }

    }


    return (
        <>
            <div className='row'>
                <div className='col-md-12'>

                    <SelectProduct options={productList} selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} />

                    {/*

                    <Autocomplete
                        options={productList}
                        onChange={(event, newValue) => {
                            setSelectedProduct(newValue);
                        }}
                        getOptionLabel={(product) => product.title}
                        value={selectedProduct}
                        forcePopupIcon={false}
                        renderInput={(params) => <TextField {...params} size="small" label="" variant="standard" /> } 
                    />
                    */}
                </div>
            </div>

            
            <Dialog
                open={item !== null}
                keepMounted
                onClose={()=>setItem(null)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    {item &&
                        <table className='table'>
                            <tbody>
                                <tr>
                                    <th>Product Name</th>
                                    <td>{item.title}</td>
                                </tr>

                                <tr>
                                    <th>HSN</th>
                                    <td>{item.hsn}</td>
                                </tr>
                                <tr>
                                    <th>Price</th>
                                    <td><input className='form-control' type='text' value={item.price} onChange={(e)=>handleItemChange("price",e.target.value)} /> </td>
                                </tr>

                                <tr>
                                    <th>Gst</th>
                                    <td><input className='form-control' type='number' value={item.gstRate} onChange={(e)=>handleItemChange("gstRate",e.target.value)} /></td>
                                </tr>

                                {item.billingType == 1 && stockList &&
                                    <tr>
                                        <th>Slect Warehouse / Godown Location
                                            <br/>
                                            <InventoryForm callBack={getStockList} />
                                        </th>
                                        <td>
                                            <select className='form-control'  value={item.location} onChange={(e)=>handleItemChange("stockId",e.target.value)}>
                                                <option value={0} > ---Select Warehouse --</option>
                                                {stockList?.map(warehouse=>
                                                    <option value={warehouse.id} key={warehouse.id}> {getDDDataById(projectLocationDD,warehouse.locationId).label}  -  {warehouse.qty} </option>
                                                )}
                                                
                                            </select>
                                            
                                        </td>
                                    </tr>
                                }
                                <tr>
                                    <th>Qty</th>
                                    <td><input className='form-control' type='number' value={item.qty} onChange={(e)=>handleItemChange("qty",e.target.value)} /> </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                
                                <tr>
                                    <td>
                                        {errorList.length > 0 && 
                                            <ul>
                                                {errorList.map((error,i)=>
                                                    <li className='text-danger' key={i}>{error}</li>
                                                )}
                                                
                                            </ul>
                                        }
                                    </td>
                                    <td><button className='btn btn-primary float-end' onClick={addItem} >Add Item</button> </td>
                                </tr>
                            </tfoot>
                        </table>
                    }
                </DialogContent>
                {/*
                <DialogContent>
                    <br/>
                    <br/>
                    {JSON.stringify(item)}
                    <br/>
                    <br/>
                    {JSON.stringify(stockList)}
                </DialogContent>
                */
                }
                


            </Dialog>
        </>
    )
}

export default InvoiceItemForm